import { Component, h, Host, Listen, State } from '@stencil/core';

@Component({
  tag: 'sofistik-language-nav',
  styleUrl: './language-nav.scss',
})
export class LanguageNav {
  @State() show: boolean = false;
  @State() hidden: boolean = true;

  @Listen('toggleLangNav', { target: 'window' })
  handleToggleLangNav() {
    this.show = !this.show;
  }

  componentDidLoad() {
    setTimeout(() => {
      this.hidden = false;
    }, 100);
  }

  render() {
    return (
      <Host
        class={{
          fadein: this.show,
          hidden: this.hidden,
        }}
      >
        <i class="fa fa-times" aria-hidden="true" onClick={() => this.handleToggleLangNav()} />
        <slot />
      </Host>
    );
  }
}
